import { createSlice } from '@reduxjs/toolkit';

const initialState = {
   selectedState: null,
};

const statesSlice = createSlice({
   name: 'states',
   initialState,
   reducers: {
      selectedState: (state, action) => {
         state.selectedState = action.payload;
      },
      clearSelectedState: (state) => {
         state.selectedState = null;
      },
   },
});

export const { selectedState, clearSelectedState } = statesSlice.actions;

export default statesSlice.reducer;
